<template>
  <div class="v-application" style="overflow-y: hidden">
    <v-app>
      <v-main>
        <Form/>
        <Success v-if="state.appStage.currentProgress == 'success'"></Success>
      </v-main>
    </v-app>
  </div>
</template>


<script>
import {mapGetters} from 'vuex'
import Form from './components/Form'
import Success from './components/Success'


export default {
  name: 'App',

  components: {
    Form,
    Success
  },

  data: () => ({
    //
  }),
  computed: {
    ...mapGetters({
      state: 'getState',
    }),
  },
  mounted: function () {
    this.$store.dispatch('getAppRates');
  }
};
</script>

<style>

.v-dues-form {
  font-family: Roboto, sans-serif !important;

}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.v-icon {
  margin-right: 10px;
}
</style>
